enum WaterVolumeTypes {
  GALLONS = 1,
  LITERS = 2
}

export const VOLUME_CONVERSION = {
  [WaterVolumeTypes.GALLONS]: 1,
  [WaterVolumeTypes.LITERS]: 3.785
};

export function toGallons(valueInUnit: number, unit: WaterVolumeTypes): number {
  return valueInUnit / VOLUME_CONVERSION[unit];
}

export function resolveVolumeValue(gallons: number, unit: WaterVolumeTypes) {
  return gallons * VOLUME_CONVERSION[unit];
}
